import { HeaderSection } from "./styled";

const Header = ({ title }) => (
    <HeaderSection>
        {title}
    </HeaderSection>
);

export default Header;